export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Who is this system for?',
    answer:
      'Registered nurses, licensed nursing professionals, hospital nurses, clinical nursing staff, and advanced nursing students looking for organized professional visual references.',
  },
  {
    question: 'What nursing subjects does it cover?',
    answer:
      'The system covers patient assessment, clinical monitoring, injection procedures, IV therapy, vascular access, wound care, medication safety, bedside procedures, and emergency nursing.',
  },
  {
    question: 'Does it include visual clinical procedure references?',
    answer:
      'Yes. The atlas includes anatomical illustrations, clinical diagrams, equipment comparisons, safety workflows, assessment charts, and professional reference tools.',
  },
  {
    question: 'Does it include ready-to-use nursing resources?',
    answer:
      'Yes. It includes assessment checklists, documentation templates, medication calculation worksheets, safety forms, clinical scenarios, and shift organization tools.',
  },
  {
    question: 'Is this suitable for beginners?',
    answer:
      'The system is designed primarily for qualified nursing professionals and advanced nursing students. It uses professional terminology and assumes existing clinical knowledge.',
  },
  {
    question: 'Does it include emergency nursing references?',
    answer:
      'Yes. It covers emergency assessment, clinical deterioration recognition, rapid response communication, emergency equipment, and common critical clinical situations.',
  },
  {
    question: 'Is this a physical product?',
    answer:
      'No. NURSING CLINICAL SKILLS VISUAL ATLAS™ is a 100% digital professional educational reference system.',
  },
  {
    question: 'Does this provide an official nursing certification?',
    answer:
      'No. It is an independent professional reference resource and does not provide nursing licensure, certification, clinical authorization, or formal competency validation.',
  },
  {
    question: 'Does it replace clinical training or hospital protocols?',
    answer:
      'No. Nursing procedures require appropriate training, professional authorization, current clinical guidelines, and institutional protocols. The atlas is intended for educational and professional reference.',
  },
  {
    question: 'How will I receive it?',
    answer: "You'll receive immediate digital access after purchase.",
  },
]
